import React, { useEffect, useState } from "react"
import { addOnChangeHook, deleteOnChangeHook } from "../../BackgroundPoller.js"
import { isOpenDuring, LUNCH_LINE_DISPLAY_NAMES, TRAFFIC_STATUS_CONV_TABLE, TRAFFIC_STATUS_CSS_TABLE } from "../../Dicts.ts"
import { ArrowDown, ArrowDownLeft, ArrowDownRight, ArrowLeft, ArrowRight, ArrowUp, ArrowUpLeft, ArrowUpRight, Clock, Dot } from 'lucide-react';
import { TrafficStatusInterface, WidgetInterface } from "../../types.ts";

interface Props {
    widget  : WidgetInterface
    editMode : boolean
    onUpdate: (id: string, updates: Partial<WidgetInterface>) => void;
}

function defaultTrafficStatusInterface() : TrafficStatusInterface {
  return {position: "", station: "koti1-vasen"}
}

function getSymbolFromDir(d : string) {
  if (d == "E")
    return (<ArrowRight />)
  else if (d == "W")
    return (<ArrowLeft />)
  else if (d == "N")
    return (<ArrowUp />)
  else if (d == "S")
    return (<ArrowDown />)
  else if (d == "SE")
    return (<ArrowDownRight />)
  else if (d == "SW")
    return (<ArrowDownLeft/>)
  else if (d == "NW")
    return (<ArrowUpLeft/>)
  else if (d == "NE")
    return (<ArrowUpRight />)
  else
    return (<Dot />)
}

function cycleSymbol(d? : string) {
  if (d == "E")
    return "SE"
  else if (d == "W")
    return "NW"
  else if (d == "N")
    return "NE"
  else if (d == "S")
    return "SW"
  else if (d == "SE")
    return "S"
  else if (d == "SW")
    return "W"
  else if (d == "NW")
    return "."
  else if (d == "NE")
    return "E"
  else
    return "N"
}

function cycleStations(station : string) : string {
  switch(station) {
    case 'koti1-vasen':
      return 'koti1-oikea';
    case 'koti1-oikea':
      return 'koti2-vasen';
    case 'koti2-vasen':
      return 'koti2-oikea';
    case 'koti2-oikea':
      return 'koti2-vege';
    case 'koti2-vege':
      return 'koti1-vasen';
    default:
      return 'koti1-vasen'
  }
}

export default function TrafficStatus(props : Props) {
    const [value, setValue] = useState(-1)
    const ts : TrafficStatusInterface = props.widget.data ? props.widget.data : defaultTrafficStatusInterface();
    const updateHook = (data) => {
        let t = new Date();
        let th = t.getHours() + t.getMinutes() / 60;
        try {
            setValue(-1)
            
            if (isOpenDuring(ts.station,th))
              if (ts.station == "koti2-vege") {
                setValue(0); //We don't have data for this, but there is always room in vegetarian line if it is open
              } else {
                setValue(data["traffic"][ts.station] as number)
              }
            else
                setValue(-2)


        } catch (e) {console.log(e)}
    };

    const handleArrowClick = () => {
        if(!props.editMode)
          return false;
        
        let newts = ts;
        newts.position = cycleSymbol(newts.position)
        
        props.onUpdate(props.widget.id, {
          data: newts
        });
    } 

    const handleStationClick = () => {
        if(!props.editMode)
          return false;
        
        let newts = ts;
        newts.station = cycleStations(newts.station)
        
        props.onUpdate(props.widget.id, {
          data: newts
        });

        setValue(-1)
    } 

    useEffect(() => {
        addOnChangeHook(updateHook)
        return () => {deleteOnChangeHook(updateHook)}
    })
    return (
              <div style={{"fontSize" : "24px"}}>
                <div style={{paddingBottom: "5px"}}>
                <span style={{"paddingRight" : "12px", "cursor" : props.editMode ? "pointer" : "default"}} onClick={handleArrowClick}>
                  {
                    getSymbolFromDir(ts.position ?? "")
                  }
                  </span>
                <span style={{"display": "inline-block", "fontSize" : "14px", "marginRight" : "12px"}}><div>Linja</div><div>Line</div></span>
                <span style={{"cursor" : props.editMode ? "pointer" : "default", fontSize: "32px", fontWeight: "800"}} className="status-title" onClick={handleStationClick}>{LUNCH_LINE_DISPLAY_NAMES[ts.station]}</span>
                </div>
                <div className={"font-sans status-display status-color "+TRAFFIC_STATUS_CSS_TABLE[value]}><span style={{paddingRight: "10px"}}><Clock /></span>{TRAFFIC_STATUS_CONV_TABLE[value]}</div>
              </div>
    )
}